//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 19.10.2016.
 */

(function () {

    'use strict';

    angular.module('container.widgets')
        .directive('srsngIpAddress', srsngIpAddress);

    function srsngIpAddress() {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/widgets/ip-address/ip-address.html',
            scope: {
                value: '='
            },
            controller: controller
        };

        function controller($scope) {

            $scope.$watch('value', newValue => {
                $scope.octets = $scope.value.split('.')
            });

            $scope.update = () => {
                $scope.value = $scope.octets.join('.');
            }
        }
    }
})();